module.exports = __webpack_public_path__ + "media/images/btn_see_mare_fees-6b99b18c91d3695dc75a11f3add97994.gif";